export const API_URL:string = "https://dashboard.thetrio.sa"